<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <p v-html="content" />
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        />
        <br />
        <p>
          Consider our All Sports Packages for your one stop shop sports betting
          needs. We offer expertise in College football picks, NFL football
          picks, college basketball picks, college football predictions, Free
          basketball picks, MLB Picks, sports betting advice, free football
          picks.
        </p>
        <h5 v-for="p in ps" :key="p.id">
          {{ p.name }}
          <purchase-button :package="p" full-width="true"></purchase-button>
          <!-- <paypal-button :package="p" size="medium" /> -->
        </h5>
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="1950798677"
          ad-style="display:inline-block;width:468px;height:60px"
          ad-format="auto"
        />
      </div>
      <!-- main-colum END here -->
      <!-- sidebar START here -->
      <sidebar :packages="packages" />
      <!-- sidebar END here -->
      <!-- </ul> -->
    </div>
    <!-- sidebar END here -->
  </div>
  <!-- container END here -->
  <!-- </div> -->
  <!-- content END here -->
</template>

<script>
import Adsense from "../components/adsense.vue";
import Sidebar from "../components/sidebar.vue";
import PaypalButton from "../components/paypalButton.vue";
import PurchaseButton from "../components/purchaseButton.vue";
import ContentRepository from "../data/content.repository.js";
import _ from "lodash";
export default {
  components: {
    adsense: Adsense,
    sidebar: Sidebar,
    purchaseButton: PurchaseButton,
    // paypalButton: PaypalButton,
  },
  data() {
    return {
      content: "",
    };
  },
  computed: {
    ps() {
      return this.$store.getters.packagesBySport(
        "2343a835-82ae-4b4b-bb50-689912b97571"
      ).filter((p) => !p.special);
    },
    packages() {
      var s = _.find(this.sports, [
        "sport",
        this.$route.params.sport.toUpperCase(),
      ]);
      if (s) return this.$store.getters.packagesBySport(s.id).filter((p) => !p.special);
      else return [];
    },
    sports() {
      return this.$store.state.sports;
    },
  },
  watch: {
    $route() {
      ContentRepository.get(this.$route.params.sport.toUpperCase()).then(
        (result) => {
          this.content = result[0].content;
        }
      );
    },
  },
  mounted() {
    ContentRepository.get(this.$route.params.sport.toUpperCase()).then(
      (result) => {
        this.content = result[0].content;
        return this.content;
      }
    );
  },
  metaInfo: {
    title:
      this.$route && this.$route.params
        ? `${this.$route.params.sport.toUpperCase()} Packages`
        : "Packages",
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Package.vue?17ade968